export default class ChartsConfigurations{
    static dashboardSalesBarOptions  = {
      chart: {
        height: "200px",
       
        id: "vuechart-example",
      },
      tooltip: {
        y: {
          formatter: (value) => {
            return value + "€";
          },
        },
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            colors: "#fff",
          },
          formatter: (value) => {
            return value + "€";
          },
        },
        axisBorder: {
          show: true,
        },
      },
      xaxis: {
        labels: {
          style: {
            colors: "#fff",
          },
        },
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "70%",
        },
      },
      grid: {
        show: false,
      },
      padding: {
        top: 0,
        right: 20,
        bottom: 0,
        left: 10,
      },
    };
    static dashboardSalesAreaOptions  = {
      tooltip: {
        y: {
          formatter: (value) => {
            return value + "€";
          },
        },
      },
      colors:["#5EC2B7"],
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 6,
        strokeWidth: 0,
      },
      yaxis: {
        min: 0,
        tickAmount: 4,
        show: true,
        labels: {
        
          style: {
            colors: "#fff",
          },
          formatter: (value) => {
            return parseInt(value) + "€";
          },
        },
        axisBorder: {
          show: true,
        },
      },
      xaxis: {
        labels: {   
          style: {
            colors: "#fff",
          },
        },
        axisBorder: {
          show: true,
        
        },
        axisTicks: {
          show: false,
        },
      },
      
      grid: {        
          show: true,
          position: "back",
          borderColor: 'RGBA(250,250,250,0.27)',
          strokeDashArray: 4,
          yaxis: {
              lines: {              
                  show: true
              }
          },
      },
      padding: {
        top: 0,
        right: 20,
        bottom: 0,
        left: 10,
      },
    };
    static dashboardClientSalesBarOptions = {
        colors:["#5EC2B7","#3B429F","#FB6376","#9BA2FF","#B99E79"],
        tooltip: {
          y: {
            formatter: (value) => {
              return parseInt(value) + "€";
            },
          },
        },
         grid: {
        show: false,
      },
      dataLabels:{
        offsetY: 20
      },
      plotOptions: {
          bar: {
            horizontal: false,
            distributed: true
          }
        },
        yaxis: {
        show: true,
        labels: {
          style: {
            colors: "#fff",
          },
          formatter: (value) => {
            return value + "€";
          },
        },
        axisBorder: {
          show: true,
        },
      },
      legend:{
          show:true,
          fontSize: "13px",
          labels:{
            colors:"#fff"
            
          },
          
          itemMargin: {
            vertical: 10,
            horizontal: 10
          }
      },
      xaxis: {
        
        labels: {
          trim: true,
          show:true,
          rotateAlways: false,
          rotate: 0,
          hideOverlappingLabels:false,
          style: {
            colors: "#fff",
          },
           formatter: (value) => { return value },
           
          
        },
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: false,
        },
      },
      
     
    };
    static dashboardProductSalesPieOptions = (labels) => {
        
        return {
         
            labels: labels,
            type: 'pie',            
            id: "pieChart-example",
            colors:["#5EC2B7","#3B429F","#FB6376","#9BA2FF","#B99E79"],
            plotOptions: {
              pie: {
                customScale: 0.8,
                 donut: {
                  size: '65%',
                 }
              }
            },
            dataLabels:{
              dropShadow:{
                enabled: false
              },
              style:{
                fontSize:"14px",
                
              }
            },
            legend: {
              
              show:true,
              fontSize:"13px",
              width:200,
            
              labels: {
                trim: true,
                colors: ['#fff']
              },
              itemMargin: {
                  horizontal: 0,
                  vertical: 7
              },
              
            },
            stroke: {
                show: false,
                curve: 'smooth',
                lineCap: 'butt',
                colors: ["#000"],
                width: 2,
                dashArray: 0,      
            },
            responsive: [{
                breakpoint: 1000,
                options: {
                   
                   legend: {
                      position: 'bottom',
                   }
                },
            }]
            
        }
       
      };
}